import React, {Component} from 'react';
import PropTypes from 'prop-types'
import {connect} from 'react-redux';
import {playCard, resetCards} from "../actions";
import {Button, Grid} from '@material-ui/core'

class PlayControl extends Component {
    render() {
        return (
            <Grid container direction={"column"} wrap={"nowrap"}  alignItems={"center"} justify={"space-evenly"} style={{height:'100%'}}>
                    <Button color={"primary"} size={"small"} variant={"outlined"}  onClick={this.props.onPlayCardClick}>Play A Card</Button>
                    <Button color={"secondary"} size={"small"} variant={"outlined"} onClick={this.props.onResetCardsClick}>Reset Cards</Button>
            </Grid>
        );
    }
}

PlayControl.propTypes = {
    onPlayCardClick: PropTypes.func.isRequired,
    onResetCardsClick: PropTypes.func.isRequired
}

function mapStateToProps(state, ownProps){
    return {
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        onPlayCardClick: function() {
            dispatch(playCard());
        },
        onResetCardsClick: function() {
            dispatch(resetCards());
        }
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PlayControl)